import { Button, Drawer, Skeleton } from "antd";
import TermsAndConditionsCard from "./terms_and_conditions_card";
import { useState, useEffect, useCallback } from "react";
import { fetchBranchTermAandConditions } from "../../../apis/branch.api";
import BranchTermsCreateForm from "./branch_terms_create_form";
import { usePermissions } from "../../../custom_hooks/permission/permission_hook";

const TermsAndConditionsList = () => {
  const [terms, setTerms] = useState<Array<any>>([]);
  const [branch_terms_add_form, setBranchTermsAddForm] = useState(false);
  const [reloadTick, setReloadTick] = useState(0);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = usePermissions();

  const letUpdate = useCallback(() => {
    setReloadTick((t) => t + 1);
  }, []);

  const showBranchTermsAddDrawer = useCallback(() => {
    setBranchTermsAddForm(true);
  }, []);

  const onTermsAddDrawerClose = useCallback(() => {
    setBranchTermsAddForm(false);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchBranchTermAandConditions()
      .then((res) => {
        if (!cancelled) setTerms(res ?? []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reloadTick]);

  return (
    <div className=" p-3 py-2">
      <div className="d-flex justify-content-between align-items-center pb-3">
        <div className="th-font-size-18 th-font-weight-600 primary-color-text align-middle">
          <div>Terms and Conditions</div>
        </div>
        <div>
          <Button
            size="middle"
            className="fw-bold"
            type="primary"
            disabled={!hasPermission("branch_details.create")}
            onClick={showBranchTermsAddDrawer}
          >
            Add Terms
          </Button>
        </div>
      </div>
      <div className="row gap-3">
        {loading && terms.length === 0 ? (
          <Skeleton active paragraph={{ rows: 3 }} />
        ) : (
          terms?.map((term) => (
            <TermsAndConditionsCard
              key={term?.id}
              term={term}
              letUpdate={letUpdate}
            />
          ))
        )}
      </div>
      <Drawer
        title="Add Terms"
        placement="right"
        closable={false}
        onClose={onTermsAddDrawerClose}
        open={branch_terms_add_form}
        destroyOnClose
      >
        <BranchTermsCreateForm
          closeDrawer={onTermsAddDrawerClose}
          letUpdate={letUpdate}
        />
      </Drawer>
    </div>
  );
};

export default TermsAndConditionsList;
